import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FinalCallToAction() {
  return <section data-section-id="252648" id="begin-your-story" className="relative bg-background text-foreground py-20 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675594/img/wedding_sunset_exit.png" alt="Wedding Sunset Exit" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-background/40 backdrop-blur-xl" />
      </div>

      <div className="page-container relative z-10 flex flex-col items-center text-center">
        <div className="bg-white/5 border border-white/10 p-12 md:p-20 rounded-lg backdrop-blur-sm flex flex-col items-center">
          <h2 className="font-default text-4xl md:text-6xl font-light mb-6 max-w-3xl leading-tight tracking-tight">
            Let's write the first chapter of your story.
          </h2>
          
          <p className="font-sans text-lg md:text-xl mb-10 max-w-2xl text-foreground/70 font-light leading-relaxed">
            Capturing the quiet glances and grand celebrations that define your unique love. We are currently accepting commissions for the upcoming season.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-lg h-14 px-10 rounded-md w-full sm:w-auto shadow-lg transition-all duration-300" asChild>
              <Link to="/InquiryPage">
                <SafeHydrate><Calendar className="mr-2 h-5 w-5" /></SafeHydrate>
                Get in Touch
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="bg-transparent border-primary/20 text-primary hover:bg-primary/5 hover:border-primary text-lg h-14 px-10 rounded-md w-full sm:w-auto transition-colors" asChild>
              <Link to="/CollectionsPage">
                View the Collections
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}